/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type IdeasEntryPointComponent = EntryPointComponent<{}, {}, {}, {}>;

export const ideasEntryPoint: EntryPoint<IdeasEntryPointComponent, {}> = createEntryPoint({
	root: JSResourceForUserVisible<IdeasEntryPointComponent>(
		/* webpackChunkName: "async-polaris-ideas-entrypoint" */ './index.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: () => ({}),
});
